"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveExtractionConfigOutputDtoSchema = exports.retrieveExtractionConfigInputDtoSchema = void 0;
const hil_extraction_config_js_1 = require("../../types/hil-extraction-config.js");
const store_extraction_config_dto_js_1 = require("./store-extraction-config.dto.js");
exports.retrieveExtractionConfigInputDtoSchema = store_extraction_config_dto_js_1.storeExtractionConfigOutputDtoSchema;
exports.retrieveExtractionConfigOutputDtoSchema = hil_extraction_config_js_1.HilExtractionConfig.schema;
//# sourceMappingURL=retrieve-extraction-config.dto.js.map